import PropTypes from 'prop-types'
import React, { Component } from 'react'
import styles from './middle.styl'

export default class MiddleTop extends Component {
  static propTypes = {
    children: PropTypes.any
  }

  render() {
    return (
      <div className={styles.wrap}>
        {this.props.children}
      </div>
    )
  }
}
